import styled from 'styled-components'
import { em, transparentize } from 'polished'
import { Icon } from '@binance-chain/honeycomb'

export const Connection = styled.div`
  display: flex;
  flex-direction: column;
  margin: -${({ theme }) => em(theme.honeycomb.size.small)} 0;
`

export const BinanceChain = styled(Icon.BinanceChain)`
  font-size: ${({ theme }) => em(theme.honeycomb.size.increased)};
`

export const Wallet = styled(Icon.WalletConnectColor)`
  font-size: ${({ theme }) => em(theme.honeycomb.size.large)};
`

export const TypeName = styled.div`
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced)};
`

export const ImgWrap = styled.div`
  &,
  img {
    width: ${({ theme }) => em(theme.honeycomb.size.increased)};
  }
`

export const Option = styled.a`
  border-radius: ${({ theme }) => em(theme.honeycomb.size.tiny)};
  padding: ${({ theme }) => em(theme.honeycomb.size.normal)};
  margin: ${({ theme }) => em(theme.honeycomb.size.tiny)} 0;
  border: 1px solid
    ${({ theme, comingSoon }) => {
      if (comingSoon) return transparentize(0.7, theme.honeycomb.color.bg.input.normal)
      return theme.honeycomb.color.bg.input.normal
    }};
  text-align: center;
  color: ${({ theme }) => theme.honeycomb.color.text.normal};
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  background: ${({ theme, comingSoon }) => {
    if (comingSoon) return transparentize(0.7, theme.honeycomb.color.bg.input.normal)
    return theme.honeycomb.color.bg.input.normal
  }};
  position: 'relative';
  ${BinanceChain} {
    fill: ${({ theme }) => theme.honeycomb.color.primary.normal};
  }
  ${Wallet} {
    fill: ${({ theme }) => theme.honeycomb.color.primary.normal};
    font-size: ${({ theme }) => em(theme.honeycomb.size.increased)};
  }
  ${TypeName} {
    opacity: ${({ comingSoon }) => (comingSoon ? 0.3 : 1)};
  }
  ${ImgWrap} {
    opacity: ${({ comingSoon }) => (comingSoon ? 0.3 : 1)};
    align-self: flex-start;
  }
  &:hover {
    border-color: ${({ theme, comingSoon }) =>
      comingSoon ? 'none' : theme.honeycomb.color.primary.normal};
    cursor: ${({ comingSoon }) => (comingSoon ? 'not-allowed' : 'pointer')};
    text-decoration: none;
  }
`

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-right: ${({ theme }) => em(theme.honeycomb.size.tiny)};
`

export const LeftContent = styled.p`
  color: ${({ theme }) => theme.honeycomb.color.text.masked};
  font-size: ${({ theme }) => em(theme.honeycomb.size.small)};
`

export const Original = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${({ theme }) => em(theme.honeycomb.size.increased)};

  > a {
    color: ${({ theme }) => theme.honeycomb.color.text.primary};
    font-size: ${({ theme }) => em(theme.honeycomb.size.reduced)};

    &:hover {
      color: ${({ theme }) => theme.honeycomb.color.primary.normal};
      font-weight: 500;
      text-decoration: none;
    }
  }
`

export const Notice = styled.div`
  color: ${({ theme }) => theme.honeycomb.color.text.masked};
  font-size: ${({ theme }) => em(theme.honeycomb.size.small)};
  margin-top: ${({ theme }) => em(theme.honeycomb.size.normal, theme.honeycomb.size.small)};
  text-align: center;
`

export const WarnMessage = styled.div`
  color: ${({ theme }) => theme.honeycomb.color.danger.normal};
  font-size: ${({ theme }) => em(theme.honeycomb.size.small)};
  text-align: center;
  margin-top: ${({ theme }) => em(theme.honeycomb.size.increased, theme.honeycomb.size.small)};
`

export const BadgeBox = styled.div``

export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  margin-right: ${({ theme }) => em(theme.honeycomb.size.normal)};
`

export const ConnectionFailed = styled.div`
  margin-top: ${({ theme }) => em(theme.honeycomb.size.increased, theme.honeycomb.size.reduced)};
  color: ${({ theme }) => theme.honeycomb.color.danger.normal};
  text-align: center;
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced)};
`
